import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule, Inject, Output, ContentChildren, forwardRef } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost, CollectionNestedOption, extractTemplate, DxTemplateHost } from 'devextreme-angular/core';
import { DOCUMENT } from '@angular/common';

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
const _c0 = ["*"];
let DxoTagBoxAnimationComponent = /*#__PURE__*/(() => {
  class DxoTagBoxAnimationComponent extends NestedOption {
    get hide() {
      return this._getOption('hide');
    }
    set hide(value) {
      this._setOption('hide', value);
    }
    get show() {
      return this._getOption('show');
    }
    set show(value) {
      this._setOption('show', value);
    }
    get _optionPath() {
      return 'animation';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTagBoxAnimationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxAnimationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTagBoxAnimationComponent,
      selectors: [["dxo-tag-box-animation"]],
      inputs: {
        hide: "hide",
        show: "show"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTagBoxAnimationComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoTagBoxAnimationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTagBoxAnimationModule = /*#__PURE__*/(() => {
  class DxoTagBoxAnimationModule {
    /** @nocollapse */static ɵfac = function DxoTagBoxAnimationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxAnimationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTagBoxAnimationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoTagBoxAnimationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTagBoxAtComponent = /*#__PURE__*/(() => {
  class DxoTagBoxAtComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'at';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTagBoxAtComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxAtComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTagBoxAtComponent,
      selectors: [["dxo-tag-box-at"]],
      inputs: {
        x: "x",
        y: "y"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTagBoxAtComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoTagBoxAtComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTagBoxAtModule = /*#__PURE__*/(() => {
  class DxoTagBoxAtModule {
    /** @nocollapse */static ɵfac = function DxoTagBoxAtModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxAtModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTagBoxAtModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoTagBoxAtModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTagBoxBoundaryOffsetComponent = /*#__PURE__*/(() => {
  class DxoTagBoxBoundaryOffsetComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'boundaryOffset';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTagBoxBoundaryOffsetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxBoundaryOffsetComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTagBoxBoundaryOffsetComponent,
      selectors: [["dxo-tag-box-boundary-offset"]],
      inputs: {
        x: "x",
        y: "y"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTagBoxBoundaryOffsetComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoTagBoxBoundaryOffsetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTagBoxBoundaryOffsetModule = /*#__PURE__*/(() => {
  class DxoTagBoxBoundaryOffsetModule {
    /** @nocollapse */static ɵfac = function DxoTagBoxBoundaryOffsetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxBoundaryOffsetModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTagBoxBoundaryOffsetModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoTagBoxBoundaryOffsetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiTagBoxButtonComponent = /*#__PURE__*/(() => {
  class DxiTagBoxButtonComponent extends CollectionNestedOption {
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get _optionPath() {
      return 'buttons';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiTagBoxButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiTagBoxButtonComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiTagBoxButtonComponent,
      selectors: [["dxi-tag-box-button"]],
      inputs: {
        location: "location",
        name: "name",
        options: "options"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiTagBoxButtonComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiTagBoxButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiTagBoxButtonModule = /*#__PURE__*/(() => {
  class DxiTagBoxButtonModule {
    /** @nocollapse */static ɵfac = function DxiTagBoxButtonModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiTagBoxButtonModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiTagBoxButtonModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxiTagBoxButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTagBoxCollisionComponent = /*#__PURE__*/(() => {
  class DxoTagBoxCollisionComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'collision';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTagBoxCollisionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxCollisionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTagBoxCollisionComponent,
      selectors: [["dxo-tag-box-collision"]],
      inputs: {
        x: "x",
        y: "y"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTagBoxCollisionComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoTagBoxCollisionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTagBoxCollisionModule = /*#__PURE__*/(() => {
  class DxoTagBoxCollisionModule {
    /** @nocollapse */static ɵfac = function DxoTagBoxCollisionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxCollisionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTagBoxCollisionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoTagBoxCollisionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiTagBoxToolbarItemComponent = /*#__PURE__*/(() => {
  class DxiTagBoxToolbarItemComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get html() {
      return this._getOption('html');
    }
    set html(value) {
      this._setOption('html', value);
    }
    get locateInMenu() {
      return this._getOption('locateInMenu');
    }
    set locateInMenu(value) {
      this._setOption('locateInMenu', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get menuItemTemplate() {
      return this._getOption('menuItemTemplate');
    }
    set menuItemTemplate(value) {
      this._setOption('menuItemTemplate', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get showText() {
      return this._getOption('showText');
    }
    set showText(value) {
      this._setOption('showText', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get toolbar() {
      return this._getOption('toolbar');
    }
    set toolbar(value) {
      this._setOption('toolbar', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get widget() {
      return this._getOption('widget');
    }
    set widget(value) {
      this._setOption('widget', value);
    }
    get _optionPath() {
      return 'toolbarItems';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiTagBoxToolbarItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiTagBoxToolbarItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiTagBoxToolbarItemComponent,
      selectors: [["dxi-tag-box-toolbar-item"]],
      inputs: {
        cssClass: "cssClass",
        disabled: "disabled",
        html: "html",
        locateInMenu: "locateInMenu",
        location: "location",
        menuItemTemplate: "menuItemTemplate",
        options: "options",
        showText: "showText",
        template: "template",
        text: "text",
        toolbar: "toolbar",
        visible: "visible",
        widget: "widget"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiTagBoxToolbarItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiTagBoxToolbarItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiTagBoxToolbarItemModule = /*#__PURE__*/(() => {
  class DxiTagBoxToolbarItemModule {
    /** @nocollapse */static ɵfac = function DxiTagBoxToolbarItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiTagBoxToolbarItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiTagBoxToolbarItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxiTagBoxToolbarItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTagBoxDropDownOptionsComponent = /*#__PURE__*/(() => {
  class DxoTagBoxDropDownOptionsComponent extends NestedOption {
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get animation() {
      return this._getOption('animation');
    }
    set animation(value) {
      this._setOption('animation', value);
    }
    get closeOnOutsideClick() {
      return this._getOption('closeOnOutsideClick');
    }
    set closeOnOutsideClick(value) {
      this._setOption('closeOnOutsideClick', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get contentTemplate() {
      return this._getOption('contentTemplate');
    }
    set contentTemplate(value) {
      this._setOption('contentTemplate', value);
    }
    get deferRendering() {
      return this._getOption('deferRendering');
    }
    set deferRendering(value) {
      this._setOption('deferRendering', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get dragAndResizeArea() {
      return this._getOption('dragAndResizeArea');
    }
    set dragAndResizeArea(value) {
      this._setOption('dragAndResizeArea', value);
    }
    get dragEnabled() {
      return this._getOption('dragEnabled');
    }
    set dragEnabled(value) {
      this._setOption('dragEnabled', value);
    }
    get dragOutsideBoundary() {
      return this._getOption('dragOutsideBoundary');
    }
    set dragOutsideBoundary(value) {
      this._setOption('dragOutsideBoundary', value);
    }
    get enableBodyScroll() {
      return this._getOption('enableBodyScroll');
    }
    set enableBodyScroll(value) {
      this._setOption('enableBodyScroll', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get fullScreen() {
      return this._getOption('fullScreen');
    }
    set fullScreen(value) {
      this._setOption('fullScreen', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hideOnOutsideClick() {
      return this._getOption('hideOnOutsideClick');
    }
    set hideOnOutsideClick(value) {
      this._setOption('hideOnOutsideClick', value);
    }
    get hideOnParentScroll() {
      return this._getOption('hideOnParentScroll');
    }
    set hideOnParentScroll(value) {
      this._setOption('hideOnParentScroll', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get maxHeight() {
      return this._getOption('maxHeight');
    }
    set maxHeight(value) {
      this._setOption('maxHeight', value);
    }
    get maxWidth() {
      return this._getOption('maxWidth');
    }
    set maxWidth(value) {
      this._setOption('maxWidth', value);
    }
    get minHeight() {
      return this._getOption('minHeight');
    }
    set minHeight(value) {
      this._setOption('minHeight', value);
    }
    get minWidth() {
      return this._getOption('minWidth');
    }
    set minWidth(value) {
      this._setOption('minWidth', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onHidden() {
      return this._getOption('onHidden');
    }
    set onHidden(value) {
      this._setOption('onHidden', value);
    }
    get onHiding() {
      return this._getOption('onHiding');
    }
    set onHiding(value) {
      this._setOption('onHiding', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get onResize() {
      return this._getOption('onResize');
    }
    set onResize(value) {
      this._setOption('onResize', value);
    }
    get onResizeEnd() {
      return this._getOption('onResizeEnd');
    }
    set onResizeEnd(value) {
      this._setOption('onResizeEnd', value);
    }
    get onResizeStart() {
      return this._getOption('onResizeStart');
    }
    set onResizeStart(value) {
      this._setOption('onResizeStart', value);
    }
    get onShowing() {
      return this._getOption('onShowing');
    }
    set onShowing(value) {
      this._setOption('onShowing', value);
    }
    get onShown() {
      return this._getOption('onShown');
    }
    set onShown(value) {
      this._setOption('onShown', value);
    }
    get onTitleRendered() {
      return this._getOption('onTitleRendered');
    }
    set onTitleRendered(value) {
      this._setOption('onTitleRendered', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get resizeEnabled() {
      return this._getOption('resizeEnabled');
    }
    set resizeEnabled(value) {
      this._setOption('resizeEnabled', value);
    }
    get restorePosition() {
      return this._getOption('restorePosition');
    }
    set restorePosition(value) {
      this._setOption('restorePosition', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get shading() {
      return this._getOption('shading');
    }
    set shading(value) {
      this._setOption('shading', value);
    }
    get shadingColor() {
      return this._getOption('shadingColor');
    }
    set shadingColor(value) {
      this._setOption('shadingColor', value);
    }
    get showCloseButton() {
      return this._getOption('showCloseButton');
    }
    set showCloseButton(value) {
      this._setOption('showCloseButton', value);
    }
    get showTitle() {
      return this._getOption('showTitle');
    }
    set showTitle(value) {
      this._setOption('showTitle', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get titleTemplate() {
      return this._getOption('titleTemplate');
    }
    set titleTemplate(value) {
      this._setOption('titleTemplate', value);
    }
    get toolbarItems() {
      return this._getOption('toolbarItems');
    }
    set toolbarItems(value) {
      this._setOption('toolbarItems', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get wrapperAttr() {
      return this._getOption('wrapperAttr');
    }
    set wrapperAttr(value) {
      this._setOption('wrapperAttr', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    heightChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    positionChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    widthChange;
    get _optionPath() {
      return 'dropDownOptions';
    }
    get toolbarItemsChildren() {
      return this._getOption('toolbarItems');
    }
    set toolbarItemsChildren(value) {
      this.setChildren('toolbarItems', value);
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'heightChange'
      }, {
        emit: 'positionChange'
      }, {
        emit: 'visibleChange'
      }, {
        emit: 'widthChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTagBoxDropDownOptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxDropDownOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTagBoxDropDownOptionsComponent,
      selectors: [["dxo-tag-box-drop-down-options"]],
      contentQueries: function DxoTagBoxDropDownOptionsComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, DxiTagBoxToolbarItemComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toolbarItemsChildren = _t);
        }
      },
      inputs: {
        accessKey: "accessKey",
        animation: "animation",
        closeOnOutsideClick: "closeOnOutsideClick",
        container: "container",
        contentTemplate: "contentTemplate",
        deferRendering: "deferRendering",
        disabled: "disabled",
        dragAndResizeArea: "dragAndResizeArea",
        dragEnabled: "dragEnabled",
        dragOutsideBoundary: "dragOutsideBoundary",
        enableBodyScroll: "enableBodyScroll",
        focusStateEnabled: "focusStateEnabled",
        fullScreen: "fullScreen",
        height: "height",
        hideOnOutsideClick: "hideOnOutsideClick",
        hideOnParentScroll: "hideOnParentScroll",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        maxHeight: "maxHeight",
        maxWidth: "maxWidth",
        minHeight: "minHeight",
        minWidth: "minWidth",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onHidden: "onHidden",
        onHiding: "onHiding",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        onResize: "onResize",
        onResizeEnd: "onResizeEnd",
        onResizeStart: "onResizeStart",
        onShowing: "onShowing",
        onShown: "onShown",
        onTitleRendered: "onTitleRendered",
        position: "position",
        resizeEnabled: "resizeEnabled",
        restorePosition: "restorePosition",
        rtlEnabled: "rtlEnabled",
        shading: "shading",
        shadingColor: "shadingColor",
        showCloseButton: "showCloseButton",
        showTitle: "showTitle",
        tabIndex: "tabIndex",
        title: "title",
        titleTemplate: "titleTemplate",
        toolbarItems: "toolbarItems",
        visible: "visible",
        width: "width",
        wrapperAttr: "wrapperAttr"
      },
      outputs: {
        heightChange: "heightChange",
        positionChange: "positionChange",
        visibleChange: "visibleChange",
        widthChange: "widthChange"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTagBoxDropDownOptionsComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoTagBoxDropDownOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTagBoxDropDownOptionsModule = /*#__PURE__*/(() => {
  class DxoTagBoxDropDownOptionsModule {
    /** @nocollapse */static ɵfac = function DxoTagBoxDropDownOptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxDropDownOptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTagBoxDropDownOptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoTagBoxDropDownOptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTagBoxFromComponent = /*#__PURE__*/(() => {
  class DxoTagBoxFromComponent extends NestedOption {
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get scale() {
      return this._getOption('scale');
    }
    set scale(value) {
      this._setOption('scale', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'from';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTagBoxFromComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxFromComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTagBoxFromComponent,
      selectors: [["dxo-tag-box-from"]],
      inputs: {
        left: "left",
        opacity: "opacity",
        position: "position",
        scale: "scale",
        top: "top"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTagBoxFromComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoTagBoxFromComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTagBoxFromModule = /*#__PURE__*/(() => {
  class DxoTagBoxFromModule {
    /** @nocollapse */static ɵfac = function DxoTagBoxFromModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxFromModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTagBoxFromModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoTagBoxFromModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTagBoxHideComponent = /*#__PURE__*/(() => {
  class DxoTagBoxHideComponent extends NestedOption {
    get complete() {
      return this._getOption('complete');
    }
    set complete(value) {
      this._setOption('complete', value);
    }
    get delay() {
      return this._getOption('delay');
    }
    set delay(value) {
      this._setOption('delay', value);
    }
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get from() {
      return this._getOption('from');
    }
    set from(value) {
      this._setOption('from', value);
    }
    get staggerDelay() {
      return this._getOption('staggerDelay');
    }
    set staggerDelay(value) {
      this._setOption('staggerDelay', value);
    }
    get start() {
      return this._getOption('start');
    }
    set start(value) {
      this._setOption('start', value);
    }
    get to() {
      return this._getOption('to');
    }
    set to(value) {
      this._setOption('to', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'hide';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTagBoxHideComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxHideComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTagBoxHideComponent,
      selectors: [["dxo-tag-box-hide"]],
      inputs: {
        complete: "complete",
        delay: "delay",
        direction: "direction",
        duration: "duration",
        easing: "easing",
        from: "from",
        staggerDelay: "staggerDelay",
        start: "start",
        to: "to",
        type: "type"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTagBoxHideComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoTagBoxHideComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTagBoxHideModule = /*#__PURE__*/(() => {
  class DxoTagBoxHideModule {
    /** @nocollapse */static ɵfac = function DxoTagBoxHideModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxHideModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTagBoxHideModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoTagBoxHideModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiTagBoxItemComponent = /*#__PURE__*/(() => {
  class DxiTagBoxItemComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get html() {
      return this._getOption('html');
    }
    set html(value) {
      this._setOption('html', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'items';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiTagBoxItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiTagBoxItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiTagBoxItemComponent,
      selectors: [["dxi-tag-box-item"]],
      inputs: {
        disabled: "disabled",
        html: "html",
        template: "template",
        text: "text",
        visible: "visible"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiTagBoxItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiTagBoxItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiTagBoxItemModule = /*#__PURE__*/(() => {
  class DxiTagBoxItemModule {
    /** @nocollapse */static ɵfac = function DxiTagBoxItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiTagBoxItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiTagBoxItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxiTagBoxItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTagBoxMyComponent = /*#__PURE__*/(() => {
  class DxoTagBoxMyComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'my';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTagBoxMyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxMyComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTagBoxMyComponent,
      selectors: [["dxo-tag-box-my"]],
      inputs: {
        x: "x",
        y: "y"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTagBoxMyComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoTagBoxMyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTagBoxMyModule = /*#__PURE__*/(() => {
  class DxoTagBoxMyModule {
    /** @nocollapse */static ɵfac = function DxoTagBoxMyModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxMyModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTagBoxMyModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoTagBoxMyModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTagBoxOffsetComponent = /*#__PURE__*/(() => {
  class DxoTagBoxOffsetComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'offset';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTagBoxOffsetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxOffsetComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTagBoxOffsetComponent,
      selectors: [["dxo-tag-box-offset"]],
      inputs: {
        x: "x",
        y: "y"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTagBoxOffsetComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoTagBoxOffsetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTagBoxOffsetModule = /*#__PURE__*/(() => {
  class DxoTagBoxOffsetModule {
    /** @nocollapse */static ɵfac = function DxoTagBoxOffsetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxOffsetModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTagBoxOffsetModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoTagBoxOffsetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTagBoxOptionsComponent = /*#__PURE__*/(() => {
  class DxoTagBoxOptionsComponent extends NestedOption {
    renderer;
    document;
    element;
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get activeStateEnabled() {
      return this._getOption('activeStateEnabled');
    }
    set activeStateEnabled(value) {
      this._setOption('activeStateEnabled', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get onClick() {
      return this._getOption('onClick');
    }
    set onClick(value) {
      this._setOption('onClick', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get stylingMode() {
      return this._getOption('stylingMode');
    }
    set stylingMode(value) {
      this._setOption('stylingMode', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get useSubmitBehavior() {
      return this._getOption('useSubmitBehavior');
    }
    set useSubmitBehavior(value) {
      this._setOption('useSubmitBehavior', value);
    }
    get validationGroup() {
      return this._getOption('validationGroup');
    }
    set validationGroup(value) {
      this._setOption('validationGroup', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'options';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTagBoxOptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTagBoxOptionsComponent,
      selectors: [["dxo-tag-box-options"]],
      inputs: {
        accessKey: "accessKey",
        activeStateEnabled: "activeStateEnabled",
        disabled: "disabled",
        elementAttr: "elementAttr",
        focusStateEnabled: "focusStateEnabled",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        icon: "icon",
        onClick: "onClick",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        rtlEnabled: "rtlEnabled",
        stylingMode: "stylingMode",
        tabIndex: "tabIndex",
        template: "template",
        text: "text",
        type: "type",
        useSubmitBehavior: "useSubmitBehavior",
        validationGroup: "validationGroup",
        visible: "visible",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxoTagBoxOptionsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxoTagBoxOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTagBoxOptionsModule = /*#__PURE__*/(() => {
  class DxoTagBoxOptionsModule {
    /** @nocollapse */static ɵfac = function DxoTagBoxOptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxOptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTagBoxOptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoTagBoxOptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTagBoxPositionComponent = /*#__PURE__*/(() => {
  class DxoTagBoxPositionComponent extends NestedOption {
    get at() {
      return this._getOption('at');
    }
    set at(value) {
      this._setOption('at', value);
    }
    get boundary() {
      return this._getOption('boundary');
    }
    set boundary(value) {
      this._setOption('boundary', value);
    }
    get boundaryOffset() {
      return this._getOption('boundaryOffset');
    }
    set boundaryOffset(value) {
      this._setOption('boundaryOffset', value);
    }
    get collision() {
      return this._getOption('collision');
    }
    set collision(value) {
      this._setOption('collision', value);
    }
    get my() {
      return this._getOption('my');
    }
    set my(value) {
      this._setOption('my', value);
    }
    get of() {
      return this._getOption('of');
    }
    set of(value) {
      this._setOption('of', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get _optionPath() {
      return 'position';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTagBoxPositionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxPositionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTagBoxPositionComponent,
      selectors: [["dxo-tag-box-position"]],
      inputs: {
        at: "at",
        boundary: "boundary",
        boundaryOffset: "boundaryOffset",
        collision: "collision",
        my: "my",
        of: "of",
        offset: "offset"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTagBoxPositionComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoTagBoxPositionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTagBoxPositionModule = /*#__PURE__*/(() => {
  class DxoTagBoxPositionModule {
    /** @nocollapse */static ɵfac = function DxoTagBoxPositionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxPositionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTagBoxPositionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoTagBoxPositionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTagBoxShowComponent = /*#__PURE__*/(() => {
  class DxoTagBoxShowComponent extends NestedOption {
    get complete() {
      return this._getOption('complete');
    }
    set complete(value) {
      this._setOption('complete', value);
    }
    get delay() {
      return this._getOption('delay');
    }
    set delay(value) {
      this._setOption('delay', value);
    }
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get from() {
      return this._getOption('from');
    }
    set from(value) {
      this._setOption('from', value);
    }
    get staggerDelay() {
      return this._getOption('staggerDelay');
    }
    set staggerDelay(value) {
      this._setOption('staggerDelay', value);
    }
    get start() {
      return this._getOption('start');
    }
    set start(value) {
      this._setOption('start', value);
    }
    get to() {
      return this._getOption('to');
    }
    set to(value) {
      this._setOption('to', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'show';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTagBoxShowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxShowComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTagBoxShowComponent,
      selectors: [["dxo-tag-box-show"]],
      inputs: {
        complete: "complete",
        delay: "delay",
        direction: "direction",
        duration: "duration",
        easing: "easing",
        from: "from",
        staggerDelay: "staggerDelay",
        start: "start",
        to: "to",
        type: "type"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTagBoxShowComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoTagBoxShowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTagBoxShowModule = /*#__PURE__*/(() => {
  class DxoTagBoxShowModule {
    /** @nocollapse */static ɵfac = function DxoTagBoxShowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxShowModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTagBoxShowModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoTagBoxShowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoTagBoxToComponent = /*#__PURE__*/(() => {
  class DxoTagBoxToComponent extends NestedOption {
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get scale() {
      return this._getOption('scale');
    }
    set scale(value) {
      this._setOption('scale', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'to';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoTagBoxToComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxToComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoTagBoxToComponent,
      selectors: [["dxo-tag-box-to"]],
      inputs: {
        left: "left",
        opacity: "opacity",
        position: "position",
        scale: "scale",
        top: "top"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoTagBoxToComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoTagBoxToComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoTagBoxToModule = /*#__PURE__*/(() => {
  class DxoTagBoxToModule {
    /** @nocollapse */static ɵfac = function DxoTagBoxToModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoTagBoxToModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoTagBoxToModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoTagBoxToModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiTagBoxButtonComponent, DxiTagBoxButtonModule, DxiTagBoxItemComponent, DxiTagBoxItemModule, DxiTagBoxToolbarItemComponent, DxiTagBoxToolbarItemModule, DxoTagBoxAnimationComponent, DxoTagBoxAnimationModule, DxoTagBoxAtComponent, DxoTagBoxAtModule, DxoTagBoxBoundaryOffsetComponent, DxoTagBoxBoundaryOffsetModule, DxoTagBoxCollisionComponent, DxoTagBoxCollisionModule, DxoTagBoxDropDownOptionsComponent, DxoTagBoxDropDownOptionsModule, DxoTagBoxFromComponent, DxoTagBoxFromModule, DxoTagBoxHideComponent, DxoTagBoxHideModule, DxoTagBoxMyComponent, DxoTagBoxMyModule, DxoTagBoxOffsetComponent, DxoTagBoxOffsetModule, DxoTagBoxOptionsComponent, DxoTagBoxOptionsModule, DxoTagBoxPositionComponent, DxoTagBoxPositionModule, DxoTagBoxShowComponent, DxoTagBoxShowModule, DxoTagBoxToComponent, DxoTagBoxToModule };
